export enum CalculationType {
    Basic = 0,
    Optimum = 1,
    Maximum = 2
}